import { render, staticRenderFns } from "./startcopy.vue?vue&type=template&id=48644b9d&scoped=true"
import script from "./startcopy.vue?vue&type=script&lang=js"
export * from "./startcopy.vue?vue&type=script&lang=js"
import style0 from "./startcopy.vue?vue&type=style&index=0&id=48644b9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48644b9d",
  null
  
)

export default component.exports